import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { Header } from "./components/Header";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Paywall from "./pages/Paywall";
import Record from "./pages/Record";
import Journal from "./pages/Journal";
import EntryDetail from "./pages/EntryDetail";
import MoodCalendar from "./pages/MoodCalendar";
import Settings from "./pages/Settings";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#060A12] text-[#F4F6FA] grain">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/paywall" element={<ProtectedRoute requirePaid={false}><Paywall /></ProtectedRoute>} />
                <Route path="/record" element={<ProtectedRoute><Record /></ProtectedRoute>} />
                <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
                <Route path="/journal/:id" element={<ProtectedRoute><EntryDetail /></ProtectedRoute>} />
                <Route path="/calendar" element={<ProtectedRoute><MoodCalendar /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0C1322", border: "1px solid rgba(229,193,88,0.25)", color: "#F4F6FA" } }} />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
